import { smoothScroll } from './modules/_smoothScroll.js';
import { aos } from './modules/_aos.js';
import { header } from './modules/_header.js';
import { marquee } from './modules/_marquee.js';

document.addEventListener('DOMContentLoaded', () => {
  smoothScroll();
  aos();
  header();
  marquee();
});

